import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import NavigationBar from '../components/NavigationBar';

const InnerPagesLayout = () => {

  return (
    <>
      <Header />
      <NavigationBar />
     
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default InnerPagesLayout;
